import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { ASK_IDX, BID_IDX, ROW_ID_COLUMN, ROW_ID_IDX, UPDATE_BUTTON_COLUMN } from "./constants";

interface SendValuesArgs {
  context: Excel.RequestContext;
  clickedCell: string;
  onUploadData: ({ securityId, updatedRow }: { securityId: string; updatedRow: number }) => Promise<void>;
}

export async function sendValues({ context, clickedCell, onUploadData }: SendValuesArgs) {
  const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);

  const clickedRow = clickedCell.substring(1);

  const completeRow = worksheet.getRange(ROW_ID_COLUMN + clickedRow + ":" + UPDATE_BUTTON_COLUMN + clickedRow);

  completeRow.load("values");
  await context.sync();

  const rowValues = completeRow.values[0];

  const rowId = rowValues[ROW_ID_IDX];
  const askValue = rowValues[ASK_IDX];
  const bidValue = rowValues[BID_IDX];

  if (!askValue && !bidValue) return;

  await onUploadData({ securityId: rowId, updatedRow: parseInt(clickedRow) });

  await context.sync();
}
